(function () {

    "use strict";

    function resetPasswordController($http, $translate, routeGenerator, $mdToast, tenantConfigurationService) {
        var vm = this;

        vm.sendMail = sendMail;

        function sendMail() {
            $http({
                method: "GET",
                cache: false,
                url: routeGenerator.generateApiRoute("resetPassword?email=" + vm.email)
            })
            .then(function () {
                vm.message = $translate.instant("AUTH.EMAILSENT");
            })
            .catch(function (error) {
                vm.messageError = $translate.instant("AUTH.EMAILERROR" + error.status);
                $mdToast.show($mdToast.simple().textContent(vm.messageError)
                    .position('top right').theme('error-toast').hideDelay(3000));
            });
        }

        function init() {
            vm.tenantConf = tenantConfigurationService.logoOpenResource.get({ time: (new Date()).getTime() },
                function (data) {
                    console.log(data);
                    vm.tenantConf.logo = data.logo;
                },
                function (error) {
                    console.log(error);
                }
            );
        }

        init();

    }

    resetPasswordController.$inject = ["$http", "$translate", "sphForms.routeGenerator", "$mdToast", "sphforms.tenantConfigurationService"];

    angular.module("sphForms.auth")
        .component("resetPassword", {
            controller: resetPasswordController,
            templateUrl: "modules/auth/components/resetPassword/resetPassword.template.html"
        });

}());
